import tw, { styled } from 'twin.macro';

export const StyledError = styled.p`
  ${tw`font-inter font-medium`}
  ${tw`text-body-s text-primary-p2`}
  ${tw`w-fit`}
`;
